/* Startseite v3 – Leinenweberei Hoffmann
   Vier unabhängige Module (Hero, Bestseller, Bewertungen, Manufaktur-Video) plus
   ein gemeinsamer Abruf der REVIEWS.io-Kennzahlen. Jedes Modul startet defensiv,
   abgeschaltete Sections brechen nichts. Die Datei wird von mehreren Sections
   eingebunden, der Guard sorgt dafür, dass sie nur einmal initialisiert. */
(function () {
  'use strict';
  if (window.HFStartseite) { window.HFStartseite.initAll(document); return; }

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var DEFAULT_STORE = 'leinenweberei-hoffmann.de';

  function qsa(scope, sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); }

  /* ---------- Wischgeste (nur Finger/Stift) ----------
     Horizontales Ziehen wird hier ausgewertet, vertikales Scrollen bleibt beim
     Browser (CSS touch-action: pan-y an den Elementen). h.start/h.move/h.end. */
  function addSwipe(el, h) {
    var sx = 0, sy = 0, st = 0, dx = 0, id = null, active = false, locked = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' || !e.isPrimary) return;
      if (e.target.closest('button')) return;
      if (h.enabled && !h.enabled()) return;
      sx = e.clientX; sy = e.clientY; st = Date.now(); dx = 0;
      id = e.pointerId; active = true; locked = false;
    });
    el.addEventListener('pointermove', function (e) {
      if (!active || e.pointerId !== id) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (!locked) {
        if (Math.abs(mx) < 8 && Math.abs(my) < 8) return;
        if (Math.abs(my) >= Math.abs(mx)) { active = false; return; }
        locked = true;
        try { el.setPointerCapture(id); } catch (err) {}
        if (h.start) h.start();
      }
      dx = mx;
      h.move(dx);
    });
    function end(e, cancelled) {
      if (!active || e.pointerId !== id) return;
      active = false;
      if (!locked) return;
      locked = false;
      var v = Math.abs(dx) / Math.max(1, Date.now() - st);
      h.end(dx, v, cancelled);
      /* nach dem Wischen keinen Klick auf Links im Slide auslösen */
      var kill = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
      el.addEventListener('click', kill, true);
      setTimeout(function () { el.removeEventListener('click', kill, true); }, 350);
    }
    el.addEventListener('pointerup', function (e) { end(e, false); });
    el.addEventListener('pointercancel', function (e) { end(e, true); });
  }
  function isCommit(dx, v, width) {
    return Math.abs(dx) > width * 0.18 || (Math.abs(dx) > 30 && v > 0.35);
  }

  /* ---------- REVIEWS.io: ein Abruf für die ganze Seite ---------- */
  var reviewsPromise = null;
  function getReviews(store) {
    if (reviewsPromise) return reviewsPromise;
    var key = 'hf-reviews:' + store;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && cached.t && (Date.now() - cached.t) < 30 * 60 * 1000 && cached.d) {
        reviewsPromise = Promise.resolve(cached.d);
        return reviewsPromise;
      }
    } catch (e) {}
    var url = 'https://api.reviews.io/timeline/data?store=' + encodeURIComponent(store) + '&per_page=100&sort=date_desc';
    reviewsPromise = fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        var slim = {
          stats: data.stats || null,
          timeline: (data.timeline || []).map(function (x) {
            var s = x._source || {};
            return { rating: s.rating, comments: s.comments, author: s.author, product_name: s.product_name };
          })
        };
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: slim })); } catch (e) {}
        return slim;
      });
    return reviewsPromise;
  }

  function formatRating(v) {
    var n = parseFloat(String(v).replace(',', '.'));
    if (isNaN(n)) return null;
    return n.toFixed(1).replace('.', ',');
  }
  function formatCount(v) {
    var n = parseInt(v, 10);
    if (isNaN(n)) return null;
    try { return n.toLocaleString('de-DE'); } catch (e) { return String(n); }
  }

  function applyStats() {
    var holder = document.querySelector('[data-hf-reviews-store]');
    var hasTargets = document.querySelector('[data-hf-rating-value],[data-hf-rating-count]');
    if (!hasTargets) return;
    var store = (holder && holder.getAttribute('data-hf-reviews-store')) || DEFAULT_STORE;
    getReviews(store).then(function (data) {
      var st = data && data.stats;
      if (!st) return;
      var avg = formatRating(st.average_rating);
      var cnt = formatCount(st.review_count != null ? st.review_count : st.results_count);
      if (avg) qsa(document, '[data-hf-rating-value]').forEach(function (el) { el.textContent = avg; });
      if (cnt) qsa(document, '[data-hf-rating-count]').forEach(function (el) { el.textContent = cnt; });
    }).catch(function () { /* statische Werte bleiben stehen */ });
  }

  /* ---------- Hero ---------- */
  function initHero(root) {
    if (root.__hfInit) return; root.__hfInit = true;
    var slides = qsa(root, '[data-hero-slide]');
    if (slides.length < 2) {
      qsa(root, '[data-hero-prev],[data-hero-next],[data-hero-dots]').forEach(function (b) { b.hidden = true; });
      return;
    }
    var dots = qsa(root, '[data-hero-dot]');
    var i = 0;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.hidden = k !== i;
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    var busy = false;

    /* Automatischer Wechsel: Takt und Fortschrittsbalken kommen beide aus dem
       Javascript, der Balken wird Bild fuer Bild gefuellt. Dadurch koennen beide nicht
       auseinanderlaufen, auch wenn ein Geraet CSS-Animationen aussetzt. Liefert ein
       Geraet gar keine Frames, springt ein Timer als Sicherheitsnetz ein. Beim
       Ueberfahren mit der Maus pausiert der Takt, nach Pfeil oder Wischen bleibt der
       Slider stehen. Bei "Bewegung reduzieren" wechselt er ohne Ueberblendung. */
    var auto = parseFloat(root.getAttribute('data-autoplay')) || 0;
    var aStopped = false, aPaused = false, aFrame = null, aTimer = null, aStart = 0, aDone = 0;
    function aNow() {
      return (window.performance && window.performance.now) ? window.performance.now() : Date.now();
    }
    function aFill(p) {
      dots.forEach(function (d, k) {
        var f = d.querySelector('.hf-hero__dot-fill');
        if (f) f.style.width = k === i ? (p * 100).toFixed(2) + '%' : '';
      });
    }
    function aQueue() {
      if (!auto || aStopped || aFrame !== null) return;
      aFrame = window.requestAnimationFrame(aStep);
    }
    function aSafety() {
      clearTimeout(aTimer);
      if (!auto || aStopped || aPaused) return;
      aTimer = setTimeout(function () {
        if (aPaused || busy) { aSafety(); return; }
        autoNext();
      }, Math.max(0, auto * 1000 - aDone) + 1200);
    }
    function aStep() {
      aFrame = null;
      if (!auto || aStopped) return;
      var t = aNow();
      if (aPaused || busy) { aStart = t - aDone; aQueue(); return; }
      aDone = t - aStart;
      if (aDone >= auto * 1000) { autoNext(); return; }
      aFill(aDone / (auto * 1000));
      aQueue();
    }
    function autoReset() {
      if (!auto || aStopped) return;
      aStart = aNow(); aDone = 0;
      aFill(0);
      aQueue();
      aSafety();
    }
    function autoNext() {
      if (!auto || aStopped) return;
      if (!reduceMotion) root.setAttribute('data-hf-anim', '');
      show(i + 1);
      autoReset();
    }
    function autoStop() {
      aStopped = true;
      clearTimeout(aTimer);
      if (aFrame !== null) { window.cancelAnimationFrame(aFrame); aFrame = null; }
      root.classList.remove('is-auto', 'is-paused');
      dots.forEach(function (d) {
        var f = d.querySelector('.hf-hero__dot-fill');
        if (f) f.style.width = '';
      });
    }
    /* Pausieren nur ueber den Bedienelementen, nicht ueber der ganzen Section: am
       Desktop fuellt die Hero fast den Bildschirm, die Maus liegt dort fast immer
       irgendwo drin. Wer einen Button oder Pfeil anvisiert, soll aber nicht
       mitten im Klick ein neues Motiv bekommen. Gleiches per Tastaturfokus. */
    var AHOT = 'a,button,[data-hero-prev],[data-hero-next],[data-hero-dots]';
    function autoPause(on) {
      if (!auto || aStopped || aPaused === on) return;
      aPaused = on;
      root.classList.toggle('is-paused', on);
      if (on) { clearTimeout(aTimer); return; }
      aStart = aNow() - aDone; aQueue(); aSafety();
    }
    if (auto) {
      root.classList.add('is-auto');
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        root.addEventListener('mouseover', function (e) {
          if (e.target.closest && e.target.closest(AHOT)) autoPause(true);
        });
        root.addEventListener('mouseout', function (e) {
          if (!e.target.closest || !e.target.closest(AHOT)) return;
          var to = e.relatedTarget;
          if (to && to.closest && root.contains(to) && to.closest(AHOT)) return;
          autoPause(false);
        });
      }
      root.addEventListener('focusin', function (e) {
        if (e.target.closest && e.target.closest(AHOT)) autoPause(true);
      });
      root.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!root.contains(document.activeElement)) autoPause(false);
        }, 0);
      });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hero-prev],[data-hero-next]');
      if (!b || !root.contains(b) || busy) return;
      autoStop();
      root.setAttribute('data-hf-anim', '');
      show(i + (b.hasAttribute('data-hero-prev') ? -1 : 1));
    });
    show(0);
    autoReset();

    /* Wischen per Finger: aktuelles Motiv folgt dem Finger, das nächste bzw.
       vorherige schiebt sich von der Seite herein. */
    var W = 0, cur = null, peek = null, peekDir = 0;
    var EASE = 'transform .35s cubic-bezier(.22,.9,.2,1)';
    function eager(slide) { qsa(slide, 'img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }
    function clearPeek() {
      if (!peek) return;
      peek.hidden = true;
      peek.classList.remove('is-peek');
      peek.style.transform = '';
      peek = null; peekDir = 0;
    }
    addSwipe(root, {
      enabled: function () { return !busy; },
      start: function () {
        autoStop();
        W = root.clientWidth || window.innerWidth;
        cur = slides[i];
        root.removeAttribute('data-hf-anim');
        root.classList.add('is-dragging');
        eager(slides[(i + 1) % slides.length]);
        eager(slides[(i - 1 + slides.length) % slides.length]);
      },
      move: function (dx) {
        var dir = dx < 0 ? 1 : -1;
        if (dir !== peekDir) {
          clearPeek();
          peekDir = dir;
          peek = slides[(i + dir + slides.length) % slides.length];
          peek.classList.add('is-peek');
          peek.hidden = false;
        }
        cur.style.transform = 'translateX(' + dx + 'px)';
        peek.style.transform = 'translateX(' + (dir * W + dx) + 'px)';
      },
      end: function (dx, v, cancelled) {
        if (!peek) { root.classList.remove('is-dragging'); cur.style.transform = ''; return; }
        var commit = !cancelled && isCommit(dx, v, W);
        var dir = peekDir, target = peek, from = cur;
        busy = true;
        from.style.transition = EASE; target.style.transition = EASE;
        from.style.transform = 'translateX(' + (commit ? -dir * W : 0) + 'px)';
        target.style.transform = 'translateX(' + (commit ? 0 : dir * W) + 'px)';
        setTimeout(function () {
          from.style.transition = ''; target.style.transition = '';
          from.style.transform = ''; target.style.transform = '';
          target.classList.remove('is-peek');
          peek = null; peekDir = 0;
          if (commit) { show(slides.indexOf(target)); } else { target.hidden = true; }
          root.classList.remove('is-dragging');
          busy = false;
        }, reduceMotion ? 0 : 360);
      }
    });
  }

  /* ---------- Bestseller-Pfeile ---------- */
  /* Die Schnellansicht-Fenster (Drawer/Popover) werden aus dem Slider heraus an das
     Seitenende gehaengt. Im Slider liegen sie sonst in einem Container mit eigener
     Scroll- und Maskenebene: auf dem Handy wird das Fenster dort beschnitten bzw.
     von den folgenden Sections ueberdeckt. Das Theme macht das fuer seine eigenen
     Drawer bereits in layout/theme.liquid. */
  function detachQuickView(root) {
    var host = document.getElementById('hf-quickview-root');
    if (!host) {
      host = document.createElement('div');
      host.id = 'hf-quickview-root';
      document.body.appendChild(host);
    }
    qsa(root, 'quick-buy-popover,quick-buy-drawer').forEach(function (el) {
      if (el.parentElement !== host) host.appendChild(el);
    });
  }

  function initBestseller(root) {
    if (root.__hfInit) return; root.__hfInit = true;
    detachQuickView(root);
    initSwatches(root);
    var rail = root.querySelector('[data-bs-rail]');
    if (!rail) return;
    function step() {
      var card = rail.querySelector('.hf-card');
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 22;
      return ((card && card.offsetWidth) || 262) * 2 + gap * 2;
    }
    var prev = root.querySelector('[data-bs-prev]');
    var next = root.querySelector('[data-bs-next]');
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  /* ---------- Farbpunkte in den Bestseller-Karten ----------
     Verhalten wie die Produktkacheln im Live-Theme: Farbwechsel erst per Klick auf
     den Punkt. Beim Überfahren werden die Bilder der Farbe nur vorgeladen, damit der
     Wechsel beim Klick sofort sitzt. Das Zweitbild zeigt das CSS, nur über dem Bild. */
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var preloaded = {};
  function preload(src, srcset, sizes) {
    if (!src || preloaded[src]) return preloaded[src];
    var pre = new Image();
    if (sizes) pre.sizes = sizes;
    if (srcset) pre.srcset = srcset;
    pre.src = src;
    preloaded[src] = new Promise(function (resolve) {
      var done = false;
      var finish = function () { if (done) return; done = true; resolve(); };
      pre.onload = function () {
        if (pre.decode) { pre.decode().then(finish, finish); setTimeout(finish, 120); } else { finish(); }
      };
      pre.onerror = finish;
      if (pre.complete && pre.naturalWidth) pre.onload();
    });
    return preloaded[src];
  }
  function preloadSwatch(sw) {
    var card = sw.closest('[data-hf-card]');
    var sizes = card && card.querySelector('[data-hf-base]') ? card.querySelector('[data-hf-base]').sizes : '';
    preload(sw.getAttribute('data-img'), sw.getAttribute('data-srcset'), sizes);
    preload(sw.getAttribute('data-img2'), sw.getAttribute('data-srcset2'), sizes);
  }
  function pickSwatch(sw) {
    var card = sw.closest('[data-hf-card]');
    if (!card || sw.classList.contains('is-active')) return;
    qsa(card, '[data-hf-swatch]').forEach(function (s) {
      var on = s === sw;
      s.classList.toggle('is-active', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    /* Links auf die gewählte Farbe setzen (wie im Live-Theme per ?variant=) */
    var vid = sw.getAttribute('data-variant');
    if (vid) {
      qsa(card, 'a[href*="/products/"]').forEach(function (a) {
        try {
          var url = new URL(a.getAttribute('href'), location.origin);
          url.searchParams.set('variant', vid);
          a.setAttribute('href', url.pathname + url.search + url.hash);
        } catch (e) {}
      });
    }
    var src = sw.getAttribute('data-img');
    if (!src) return;
    card.__hfPick = sw;
    var base = card.querySelector('[data-hf-base]');
    var hover = card.querySelector('[data-hf-hover]');
    var src2 = sw.getAttribute('data-img2');
    var srcset = sw.getAttribute('data-srcset');
    var alt = sw.getAttribute('data-alt');
    preloadSwatch(sw);
    preload(src, srcset, base ? base.sizes : '').then(function () {
      if (card.__hfPick !== sw) return; /* inzwischen andere Farbe gewählt */
      if (base) {
        if (srcset) base.srcset = srcset;
        base.src = src;
        if (alt != null) base.alt = alt;
      }
      if (hover) {
        if (src2) {
          hover.srcset = sw.getAttribute('data-srcset2') || '';
          hover.src = src2;
          hover.hidden = false;
        }
        card.classList.toggle('has-hover', !!src2);
      }
    });
  }
  function initSwatches(root) {
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-hf-swatch-more]');
      if (more && root.contains(more)) {
        e.preventDefault();
        var list = more.closest('.hf-swatches');
        qsa(list, '[data-hf-swatch][hidden]').forEach(function (s) { s.hidden = false; });
        more.setAttribute('aria-expanded', 'true');
        more.hidden = true;
        return;
      }
      var sw = e.target.closest('[data-hf-swatch]');
      if (sw && root.contains(sw)) { e.preventDefault(); pickSwatch(sw); }
    });
    if (canHover) {
      root.addEventListener('mouseover', function (e) {
        var sw = e.target.closest('[data-hf-swatch]');
        if (sw && root.contains(sw)) preloadSwatch(sw);
      });
    }
    /* Touch: Zweitbild nur, solange der Finger auf dem Bild liegt */
    var touched = null;
    var clear = function () { if (touched) { touched.classList.remove('is-touched'); touched = null; } };
    root.addEventListener('touchstart', function (e) {
      var media = e.target.closest('.hf-card__media');
      if (!media) return;
      var card = media.closest('[data-hf-card]');
      if (touched && touched !== card) clear();
      touched = card;
      card.classList.add('is-touched');
    }, { passive: true });
    root.addEventListener('touchend', clear, { passive: true });
    root.addEventListener('touchcancel', clear, { passive: true });
  }

  /* ---------- Bewertungs-Karussell (Desktop 3D, Mobil Slide) ---------- */
  function cleanProduct(name) {
    if (!name) return '';
    var base = String(name).split(' / ')[0].trim();
    /* doppelte Wörter direkt hintereinander entfernen ("Weiß Weiß"), Unicode-sicher */
    return base.replace(/(^|\s)(\S+)(?:\s+\2)+(?=\s|$)/gu, '$1$2');
  }
  function cleanAuthorKey(name) {
    if (!name) return '';
    var base = String(name).split(',')[0].toLowerCase().replace(/\s+/g, ' ').trim();
    if (!base || base.indexOf('anonym') === 0) return '';
    return base;
  }
  /* Nachname auf den Anfangsbuchstaben kürzen: "Alexandra Kimmich" -> "Alexandra K." */
  function shortAuthor(name) {
    var n = String(name || '').split(',')[0].replace(/\s+/g, ' ').trim();
    if (!n || /^anonym/i.test(n)) return 'Verifizierter Kauf';
    var parts = n.split(' ');
    if (parts.length < 2) return n;
    var last = parts[parts.length - 1];
    return parts.slice(0, -1).join(' ') + ' ' + last.charAt(0).toUpperCase() + '.';
  }
  /* Produktname für die Autorzeile kürzen: Farbe/Variante nach " in ", " mit ", "(" weglassen */
  function shortProduct(name) {
    var n = String(name || '').split(/\s+(?:in|mit)\s+|\s*\(/)[0].trim();
    if (n.length > 40) n = n.slice(0, 40).replace(/\s+\S*$/, '') + '…';
    return n;
  }
  function buildCard(rev) {
    var card = document.createElement('figure');
    card.className = 'hf-rev__card';
    var r = Math.max(1, Math.min(5, Math.round(rev.rating || 5)));
    var stars = document.createElement('div');
    stars.className = 'hf-rev__stars';
    stars.setAttribute('aria-label', r + ' von 5 Sternen');
    stars.textContent = '★★★★★'.slice(0, r) + '☆☆☆☆☆'.slice(0, 5 - r);
    var q = document.createElement('blockquote');
    q.className = 'hf-rev__quote';
    q.textContent = '„' + String(rev.comments || '').replace(/\s+/g, ' ').trim() + '“';
    var cap = document.createElement('figcaption');
    cap.className = 'hf-rev__author';
    var prod = shortProduct(cleanProduct(rev.product_name));
    cap.textContent = shortAuthor(rev.author) + (prod ? ' · ' + prod : '');
    card.appendChild(stars); card.appendChild(q); card.appendChild(cap);
    return card;
  }

  function initReviews(root) {
    if (root.__hfInit) return; root.__hfInit = true;
    var stage = root.querySelector('[data-rev-stage]');
    if (!stage) return;
    var cur = 0, timer = null;
    var interval = (parseInt(root.getAttribute('data-autoplay'), 10) || 11) * 1000;

    function cards() { return Array.prototype.slice.call(stage.children); }

    /* Mobil wachsen/schrumpfen die Karten in der Hoehe: die Buehne bekommt die Hoehe
       der gerade sichtbaren Karte, damit unter kurzen Zitaten kein Leerraum steht.
       Desktop behaelt die feste Hoehe (3D-Karussell). */
    var wrapEl = root.querySelector('.hf-rev__stagewrap');
    function fitHeight(list) {
      if (!wrapEl) return;
      if (window.innerWidth >= 1024) { wrapEl.style.height = ''; return; }
      var card = list[cur];
      if (!card) return;
      var h = card.offsetHeight;
      if (!h) return;
      if (!wrapEl.style.transition) wrapEl.style.transition = 'height .4s cubic-bezier(.22,.9,.2,1)';
      wrapEl.style.height = h + 'px';
    }

    function layout(drag) {
      var dragging = typeof drag === 'number';
      var list = cards();
      var n = list.length;
      if (!n) return;
      var w = stage.clientWidth || 700;
      var mobile = window.innerWidth < 1024;
      list.forEach(function (card, i) {
        var d = i - cur;
        if (d > n / 2) d -= n;
        if (d < -n / 2) d += n;
        var abs = Math.abs(d);
        if (mobile) {
          card.style.width = '100%';
          card.style.transformOrigin = '50% 50%';
          card.style.transform = 'translateX(-50%) translateX(' + (d * w + (dragging ? drag : 0)) + 'px)';
          card.style.opacity = (dragging ? abs <= 1 : d === 0) ? '1' : '0';
          card.style.filter = 'none';
        } else {
          var a = d * 0.7;
          var x = Math.sin(a) * (w * 0.62);
          var z = Math.cos(a) * 340 - 340;
          card.style.width = Math.min(440, w * 0.62) + 'px';
          card.style.transformOrigin = '50% 0%';
          card.style.transform = 'translateX(-50%) translate3d(' + x + 'px,' + (abs * 10) + 'px,' + z + 'px)' +
            ' rotateY(' + (-d * 26) + 'deg) scale(' + (abs === 0 ? 1.32 : 0.66) + ')';
          card.style.opacity = abs === 0 ? '1' : (abs === 1 ? '0.2' : '0');
          card.style.filter = abs === 0 ? 'none' : 'blur(2.5px)';
        }
        card.style.zIndex = String(10 - abs);
        card.style.pointerEvents = abs === 0 ? 'auto' : 'none';
        card.setAttribute('aria-hidden', abs === 0 ? 'false' : 'true');
      });
      if (!dragging) fitHeight(list);
    }

    function go(dir, manual) {
      if (manual && timer) { clearInterval(timer); timer = null; }
      var n = cards().length;
      if (!n) return;
      cur = (cur + dir + n) % n;
      layout();
    }

    var prev = root.querySelector('[data-rev-prev]');
    var next = root.querySelector('[data-rev-next]');
    if (prev) prev.addEventListener('click', function () { go(-1, true); });
    if (next) next.addEventListener('click', function () { go(1, true); });

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(layout, 80); });

    function startAutoplay() {
      if (reduceMotion || timer) return;
      timer = setInterval(function () {
        if (!root.isConnected) { clearInterval(timer); return; }
        go(1);
      }, interval);
    }

    layout();
    startAutoplay();

    /* Mobil: Kommentare per Finger wechseln (wie ein Slider) */
    var wrap = root.querySelector('.hf-rev__stagewrap') || stage;
    addSwipe(wrap, {
      enabled: function () { return window.innerWidth < 1024 && cards().length > 1; },
      start: function () {
        if (timer) { clearInterval(timer); timer = null; }
        stage.classList.add('is-dragging');
      },
      move: function (dx) { layout(dx); },
      end: function (dx, v, cancelled) {
        stage.classList.remove('is-dragging');
        if (!cancelled && isCommit(dx, v, stage.clientWidth || 300)) { go(dx < 0 ? 1 : -1, true); } else { layout(); }
      }
    });

    /* Live-Bewertungen aus REVIEWS.io; die gepflegten Blöcke bleiben Fallback */
    if (root.getAttribute('data-dynamic') !== '1') return;
    var store = root.getAttribute('data-hf-reviews-store') || DEFAULT_STORE;
    var max = parseInt(root.getAttribute('data-max'), 10) || 5;
    var maxLen = parseInt(root.getAttribute('data-maxlen'), 10) || 170;
    var filterRaw = root.getAttribute('data-filter') || '';
    var filterRe = null;
    try { if (filterRaw) filterRe = new RegExp(filterRaw, 'i'); } catch (e) { filterRe = null; }

    getReviews(store).then(function (data) {
      var list = (data.timeline || []).filter(function (s) {
        if (!s || s.rating < 5) return false;
        var c = String(s.comments || '').replace(/\s+/g, ' ').trim();
        if (c.length < 30 || c.length > maxLen) return false;
        if (filterRe && !filterRe.test(String(s.product_name || ''))) return false;
        return true;
      });
      var seenAuthor = {}, seenProduct = {}, picked = [];
      /* zuerst Produktbewertungen (mit Produktbezug), dann Shop-Bewertungen */
      var ordered = list.filter(function (s) { return !!s.product_name; }).concat(list.filter(function (s) { return !s.product_name; }));
      for (var i = 0; i < ordered.length && picked.length < max; i++) {
        var who = cleanAuthorKey(ordered[i].author);
        if (who && seenAuthor[who]) continue;
        var prodKey = cleanProduct(ordered[i].product_name);
        if (prodKey && seenProduct[prodKey]) continue;
        if (who) seenAuthor[who] = true;
        if (prodKey) seenProduct[prodKey] = true;
        picked.push(ordered[i]);
      }
      if (picked.length < Math.min(3, max)) return;
      var frag = document.createDocumentFragment();
      picked.forEach(function (rev) { frag.appendChild(buildCard(rev)); });
      stage.innerHTML = '';
      stage.appendChild(frag);
      cur = 0;
      root.setAttribute('data-live', '1');
      layout();
    }).catch(function () {});
  }

  /* ---------- Manufaktur-Video ----------
     Klick auf Play oeffnet einen grossen Player ueber der Seite (eigenes Fenster am
     Seitenende, damit nichts von den Sections darueber liegt). Vollbild macht der
     Nutzer bei Bedarf ueber die Steuerung des Players. Schliessen per X, Klick
     daneben oder Esc. Frueher: Abspielen im Feld bzw. erzwungenes Vollbild. */
  function openVideo(tpl, opener) {
    var lb = document.createElement('div');
    lb.className = 'hf-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Video');
    var inner = document.createElement('div');
    inner.className = 'hf-lb__inner';
    inner.appendChild(tpl.content.cloneNode(true));
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'hf-lb__close';
    close.setAttribute('aria-label', 'Video schliessen');
    close.textContent = '\u00d7';
    lb.appendChild(inner);
    lb.appendChild(close);
    document.body.appendChild(lb);
    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var v = inner.querySelector('video');
    if (v) {
      v.setAttribute('playsinline', '');
      v.controls = true;
      v.preload = 'auto';
      v.muted = false;
      v.load();
      var p = v.play();
      // Ohne Nutzergeste laesst der Browser nur stummes Abspielen zu.
      if (p && p.catch) p.catch(function () {
        v.muted = true;
        var q = v.play();
        if (q && q.catch) q.catch(function () {});
      });
    }
    function done() {
      if (v) { try { v.pause(); } catch (err) {} }
      document.documentElement.style.overflow = prevOverflow;
      document.removeEventListener('keydown', onKey);
      if (lb.parentElement) lb.parentElement.removeChild(lb);
      if (opener && opener.focus) opener.focus();
    }
    function onKey(e) { if (e.key === 'Escape' || e.key === 'Esc') done(); }
    document.addEventListener('keydown', onKey);
    close.addEventListener('click', done);
    lb.addEventListener('click', function (e) { if (e.target === lb) done(); });
  }

  function initVideo(root) {
    if (root.__hfInit) return; root.__hfInit = true;
    var btn = root.querySelector('[data-hf-video-play]');
    var tpl = root.querySelector('template[data-hf-video]');
    if (!btn || !tpl) return;
    btn.addEventListener('click', function () { openVideo(tpl, btn); });
  }

  function initAll(scope) {
    scope = scope || document;
    qsa(scope, '[data-hf-hero]').forEach(initHero);
    qsa(scope, '[data-hf-bestseller]').forEach(initBestseller);
    qsa(scope, '[data-hf-reviews]').forEach(initReviews);
    qsa(scope, '[data-hf-manufaktur]').forEach(initVideo);
    applyStats();
  }

  window.HFStartseite = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  /* Theme-Editor: neu gerenderte Sections initialisieren */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
